import React from "react"
import { Link } from "gatsby"
import Container from "react-bootstrap/Container"
import Col from "react-bootstrap/Col"
import { PaperAirplaneIcon } from "@primer/octicons-react"
import Scroller from "./Scroller"
import Zoom from "react-reveal/Zoom"
import Flash from "react-reveal/Flash"
import Reveal from "react-reveal/Reveal"
import bgVideoStyles from "./backgrondVideo.module.scss"
import SpaceShip from "../../video/SpaceShip.mp4"

const BackgroundVideo = () => {
  return (
    <section className={bgVideoStyles.header}>
      <Col className={bgVideoStyles.overlay}></Col>
      <video
        className={`pb-5 ${bgVideoStyles.video}`}
        playsInline="playsinline"
        autoPlay="autoplay"
        muted="muted"
        loop="loop"
      >
        <source src={SpaceShip} type="video/mp4" />
        <track
          src="captions_en.vtt"
          kind="captions"
          srcLang="en"
          label="english_captions"
        />
      </video>
      <Container className={`h-100 ${bgVideoStyles.container}`}>
        <Col className="d-flex h-100 text-center align-items-center p-0">
          <Col className="w-100 text-white p-0">
            <Reveal bottom forever={true}>
              <h1 className={`lead mt-4 pt-4 ${bgVideoStyles.subheading}`}>
                Welcome to my portfolio <br /> I am a software developer from
                London
              </h1>
            </Reveal>
            <hr className="mx-5 mt-0" style={{ background: "#f15842" }} />
            <Zoom>
              <Scroller />
            </Zoom>
            <Flash delay={10000}>
              <Link
                type="button"
                role="button"
                className={`btn btn-lg btn-outline-light mt-5 pl-1 pr-3 text-monospace ${bgVideoStyles.customBtn}`}
                to="/Contact"
              >
                <span
                  className={`badge badge-pill ${bgVideoStyles.customBadge}`}
                >
                  <PaperAirplaneIcon size={16} aria-label="Design icon" />
                </span>
                <strong>CONTACT </strong>
              </Link>
            </Flash>
          </Col>
        </Col>
      </Container>
    </section>
  )
}

export default BackgroundVideo
